import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Mailbox = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    viewBox="0 0 25 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M19.3333334,3.99999995 C19.7015232,3.99999995 20.0000001,4.29847679 20.0000001,4.66666662 L20.0000001,4.66666662 L20.0000001,7.3333333 C20.0000001,7.70152314 19.7015232,7.99999995 19.3333334,7.99999995 L19.3333334,7.99999995 L15.9999999,7.99999995 L16.0002316,8.71394881 C18.2101346,9.03009992 19.9203264,10.8942507 19.9972943,13.1728885 L19.9999999,13.3333333 L19.9999999,19.3333334 C19.9999999,19.6752239 19.7426399,19.9570048 19.4110808,19.9955149 L19.3333334,20.0000001 L4.66666662,20.0000001 C4.32477606,20.0000001 4.04299518,19.7426399 4.0044851,19.4110808 L3.99999995,19.3333334 L3.99999995,13.3333333 C3.99999995,10.8095086 6.00300256,8.75392626 8.50622183,8.66937241 L8.66666665,8.66666665 L14.6659999,8.66599995 L14.6666667,4.66666662 C14.6666667,4.29847679 14.9651435,3.99999995 15.3333334,3.99999995 Z M8.66666665,9.99999999 C6.87397428,9.99999999 5.41211126,11.4146869 5.33641257,13.1887257 L5.33333329,13.3333333 L5.33333329,18.6666667 L12,18.6666667 L12,13.3333333 C12,11.540641 10.5853131,10.078778 8.81127427,10.0030793 L8.66666665,9.99999999 Z M14.6659999,9.99999995 L11.932,9.99999999 L11.9665712,10.0334288 C12.7666013,10.833459 13.2774634,11.9226572 13.3290222,13.1308885 L13.3333333,13.3333333 L13.3333333,18.6666667 L18.6666667,18.6666667 L18.6666667,13.3333333 C18.6666667,11.7208234 17.5220671,10.375982 16.0009015,10.0668427 L16,13.3333333 C16,13.7015232 15.7015232,14 15.3333334,14 C14.9914428,14 14.7096619,13.7426399 14.6711518,13.4110808 L14.6666667,13.3333333 L14.6659999,9.99999995 Z M9.99999999,13.3333333 C10.3681898,13.3333333 10.6666666,13.6318102 10.6666666,14 C10.6666666,14.3418906 10.4093065,14.6236715 10.0777474,14.6621815 L9.99999999,14.6666667 L7.3333333,14.6666667 C6.96514347,14.6666667 6.66666663,14.3681898 6.66666663,14 C6.66666663,13.6581095 6.92402676,13.3763286 7.25558589,13.3378185 L7.3333333,13.3333333 L9.99999999,13.3333333 Z M18.6666667,5.33333329 L16,5.33333329 L16,6.66666663 L18.6666667,6.66666663 L18.6666667,5.33333329 Z"
        id="path-1-mailbox"
      ></path>
    </defs>
    <g
      id="icon-24x24px[16x16px]---line&amp;solid"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Atom/icon/email/mailbox/line"
        transform="translate(1.000000, 0.000000)"
      >
        <mask id="mask-2-mailbox" fill={props.color || theme.palette.grey600}>
          <use xlinkHref="#path-1-mailbox"></use>
        </mask>
        <use
          id="Combined-Shape"
          fill={props.color || theme.palette.grey600}
          fillRule="nonzero"
          xlinkHref="#path-1-mailbox"
        ></use>
        <g
          id="Group"
          mask="url(#mask-2-mailbox)"
          fill={props.color || theme.palette.grey600}
        >
          <g id="🎨-color">
            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
